module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEQSURBVHgBlVOBjcIwDHReP0A3aEbIT0B/AzYAJoANYAQ2KEwATFA2KBsAE9ANwkW9SlVwS3PSyamdnF3HMaLAe5/BLEBH1w28GGMekgqIWfDuW9RgxfULnEsqKBZooyQniroUsSWrsUoso2A1pvETfc/Aq9Yr+BqYA2glQTAgG9nfyBfEguE2LW9ZQwFeZSrYp3AhpRLbdf0Ft/4Tob/5b/9Q6BOcKywr2AL2LO1vFuQu9Bexi1JPg9hTq3LDbBrKaJwyVvzZJjorim3BWS/mOFJ30tFfRwmd6TLB1Dz/P/TEWN1J2tH5o817LTt2G/dDA62Jjg547wWUMhHYu2YBhRZ0U6tTilgMbcglEX5g+N/3e0+3QVZkuAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/lixian_bai.png
// module id = 5TTp
// module chunks = 5